<template>
  <section class="button-full-video">
    <div>
      <h2 class="button-full-video_title">
        <span v-html="shopifyData.sectionUpperTitle" />
        <span v-html="shopifyData.sectionLowerTitle" />
      </h2>
      <div class="video_container">
        <div v-if="showOverlay" class="video_overlay" />
        <video
          ref="videoElement"
          :poster="shopifyData.poster"
          loop="true"
          :muted="!playAudio"
          :controls="showControls"
          controlsList="nodownload"
          disablepictureinpicture
          webkit-playsinline="true"
          playsinline="true"
          preload="auto"
        >
          <source :src="shopifyData.videolink" />
        </video>
        <span v-if="showPlayButton" class="button-full-video_playButton" @click="playVideo">
          <svg
            width="47"
            height="50"
            viewBox="0 0 47 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M43.3192 30.2698C47.4944 27.997 47.4944 22.003 43.3193 19.7302L9.36867 1.2489C5.37054 -0.927513 0.5 1.96658 0.5 6.5187L0.5 43.4813C0.5 48.0334 5.37054 50.9275 9.36866 48.7511L43.3192 30.2698Z"
              fill="white"
            />
          </svg>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showOverlay: true,
      showPlayButton: true,
      showControls: false, // Initially, hide video controls
      playAudio: false, // Initially, mute
      observer: null, // Initialize observer variable
    };
  },
  mounted() {
    const video = this.$refs.videoElement;
    video.addEventListener('pause', this.handlePause);

    // Set up Intersection Observer
    this.observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.5,
    });

    this.observer.observe(video);
  },
  beforeUnmount() {
    const video = this.$refs.videoElement;
    video.removeEventListener('pause', this.handlePause);
    this.observer.disconnect();
  },
  methods: {
    playVideo() {
      this.playAudio = true; // Set audio to play
      this.$refs.videoElement.muted = false; // Unmute the video
      this.$refs.videoElement.play(); // Play the video
      this.showOverlay = false; // Hide the overlay
      this.showPlayButton = false; // Hide the play button
      this.showControls = true; // Show the video controls
    },
    handlePause() {
      this.showOverlay = true; // Show overlay when paused
      this.showPlayButton = true; // Show play button when paused
      this.showControls = false; // Optionally hide controls when paused
    },
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.$refs.videoElement.play(); // Play video when in view
          this.showOverlay = false; // Hide overlay when in view
          this.showPlayButton = false; // Hide play button when in view
          this.showControls = true; // Show video controls when in view
        } else {
          this.$refs.videoElement.pause(); // Pause video when out of view
        }
      });
    },
  },
};
</script>

<style scoped>
.button-full-video {
  margin-bottom: 80px;
}

.button-full-video_title {
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 16px;
}

.button-full-video_title span {
  font-size: 57px;
  font-style: italic;
  font-weight: 200;
  line-height: 1.5;
  text-align: center;
  color: #581a1a;
  font-family: 'PP Editorial New', sans-serif;
}

.video_container {
  position: relative;
}

.video_overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: #5b373a;
  opacity: 0.5;
}

.button-full-video video {
  display: block;
}

.button-full-video_playButton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  cursor: pointer;
}

.button-full-video_playButton svg {
  transition: transform 0.3s;
}

.button-full-video_playButton svg:hover {
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .button-full-video_title span {
    font-size: 47px;
  }
}

@media screen and (max-width: 567px) {
  .button-full-video_title span {
    display: block;
    font-size: 35px;
    line-height: 50.05px;
  }

  .button-full-video_playButton svg {
    transform: scale(0.6);
  }

  .button-full-video_title {
    padding: 13px;
    display: block;
  }

  .button-full-video {
    margin-bottom: 40px;
  }
}
</style>
